<template>
  <div class="grey lighten-5 home">
      <FormRenderer :id="form_id"/>
  </div>
</template>

<script>
// @ is an alias to /src
import FormRenderer from "../components/FormRenderer";

export default {
  name: "Home",
  props: ["id"],
  data: function() {
    var default_id = "RklNU2NoZW1hTm9kZTo5";
    if(this.$props.id) {
      default_id = this.$props.id;
    }
    return {
      "form_id": default_id
    }
  },
  methods: {
    "updateForm": function (newVal) {
      this.$data.id = newVal;
    }
  },
  watch: {
    "id": function (newVal) {
     this.form_id  = newVal;
    }
  },
  components: {
    FormRenderer,
  }
};
</script>
